import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 77px;
  width: 223px;
  background-color: #F8FBFC;
  border-radius: 8px;
  padding: 8px 16px;
  color: #515C66;
  font-weight: 400;
  font-size: 14px;
  margin-bottom: 15px;

`;

export const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 13px;
  line-height: 25px;
  letter-spacing: -0.2px;
`;

export const Count = styled.div`
  color: #515C66;
  font-weight: 600;
`;